<template src="../templates/normal_fcont_131.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import ReleaseDateForArticle from '../components/ReleaseDateForArticle'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink';
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import AppDownloadSmartPanel from '../components/AppDownloadSmartPanel'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '131',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,ReleaseDateForArticle,InfoMachineTranslation,
    AppDownloadSmartPanel
  },
  
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['131-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['131-2']}
    ]};
  }
  
};
</script>
<style >
</style>

